const IconApply = (props) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.91667 4.58333L4.16667 5.83333L6.25001 3.75M2.91667 9.58333L4.16667 10.8333L6.25001 8.75M2.91667 14.5833L4.16667 15.8333L6.25001 13.75M9.16667 5H16.6667M9.16667 10H16.6667M9.16667 15H16.6667'
        stroke='currentColor' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
    </svg>

)
}

export default IconApply
